import React from "react";
import {graphql} from "react-apollo";
import {flowRight as compose} from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {Map} from "immutable";
import Form from "./AddSerialsForm";
import {GET_CLIENT_DISPATCH} from "../../../queries/clientDispatches";
import {cancelAddSerialsToClientDispatch, successAddSerialsToClientDispatch} from "../../../actions/ClientDispatchApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";

function validateForm(values) {
  if (!values.get("serialNrs", "").trim()) return {serialNrs: "Enter at least one serial number."};
  return {};
}

class AddSerialsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = {clientDispatchId: this.props.clientDispatchId, serialNrs: [values.get("serialNrs", "")]};

    return this.props.addSerials(data)
      .then((response) => {
        const errors = response.data.addSerialsToClientDispatch.errors;
        if (errors.length <= 0) {
          this.props.successAddSerialsToClientDispatch();
        } else {
          // Problems are keyed by serial number, which no field has, so list
          // them all as the form's error.
          this.setState({errors: createValidationErrors(errors, errors.map((error) => error.message).join("\n"))});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  render() {
    const {dispatchData} = this.props;
    if (dispatchData.loading) return <Loading />
    if (dispatchData.error) return <GraphQLErrors error={dispatchData.error} />

    return (
      <Form
        initialValues={Map({serialNrs: ""})}
        serialsPending={dispatchData.clientDispatch ? dispatchData.clientDispatch.serialsPending : 0}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelAddSerialsToClientDispatch()}
        />
    )
  }
}

const ADD_SERIALS = gql`
  mutation addSerialsToClientDispatch($data: AddSerialsToClientDispatchInput!) {
    addSerialsToClientDispatch(input: $data) {
      errors { key message }
    }
  }
`;

const withData = compose(
  graphql(GET_CLIENT_DISPATCH, {
    name: "dispatchData",
    options: (props) => ({fetchPolicy: "network-only", variables: {id: props.clientDispatchId}})
  }),
  graphql(ADD_SERIALS, {
    props: ({mutate}) => ({addSerials: (data) => mutate({variables: {data}})})
  }),
);

export default connect(null, {
  cancelAddSerialsToClientDispatch,
  successAddSerialsToClientDispatch,
})(withData(AddSerialsFormContainer));
